<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards path="/layout/list/onlineLearning"></imgBigCards> -->
    <!--第一个大模块  -->
    <div class="top-detail">
      <!-- onlineDetailsCards组件 -->
      <onlineDetailsCards
        :info="mydata.articleInfo"
        :key="mydata.articleInfo.id"
      >
        <template #collect>
          <!-- 加入收藏 -->
          <div
            v-if="mydata.articleInfo.is_collect === 0"
            class="box-collect"
            style="cursor: pointer"
            @click="isCollect"
          >
            <el-icon><Star /></el-icon>
            <p>加入收藏</p>
          </div>
          <!-- 取消收藏 -->
          <div
            v-else
            @click="isCollect"
            class="box-collect"
            style="cursor: pointer"
          >
            <el-icon class="collectTrue"><Star /></el-icon>
            <p class="collectTrue">取消收藏</p>
          </div>
        </template>
      </onlineDetailsCards>
    </div>
    <!-- 内容部分 -->
    <div class="box-content">
      <div class="box-left">
        <!-- 课程简介 -->
        <div class="left-list">
          <el-tabs
            v-model="activeName"
            class="demo-tabs"
            @tab-click="handleClick"
          >
            <el-tab-pane label="课程简介" name="first"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 主题内容 -->
        <div class="left-main">
          <p class="tableA" v-html="mydata.articleInfo.content"></p>
        </div>
        <!-- 大家还看了 -->
        <div class="left-foot">
          <div class="left-two-box">
            <column title="大家还看了">
              <template #abc>
                <ul>
                  <li
                    class="my-li hover-change-color"
                    v-for="(item, index) in mydata.articleListArr"
                    :key="index"
                    style="cursor: pointer"
                    @click="detailsClick(item.id)"
                  >
                    <p>{{ item.title }}</p>
                    <p>
                      {{ dayjs(item.release_time * 1000).format("YYYY-MM-DD") }}
                    </p>
                  </li>
                </ul>
              </template>
            </column>
          </div>
        </div>
      </div>
      <!-- 右侧推荐区域 -->
      <div>
        <!-- 必备好书 -->
        <rightCardBook title="必备好书"></rightCardBook>
        <!-- 必刷好题 -->
        <rightCardProblem title="必刷好题"></rightCardProblem>
        <!-- 必学好课 -->
        <!-- <rightCardCourse title="必学好课"></rightCardCourse> -->
      </div>
    </div>
  </div>
</template>

<script setup>
// import { Calendar } from "@element-plus/icons-vue";
// import { View } from "@element-plus/icons-vue";
// import { Download } from "@element-plus/icons-vue";
// import { Menu } from "@element-plus/icons-vue";
// import { Lock } from "@element-plus/icons-vue";

// 必备好书
import rightCardBook from "@/components/rightCardBook/index.vue";
// 必刷好题
import rightCardProblem from "@/components/rightCardProblem/index.vue";
// 必学好课
import rightCardCourse from "@/components/rightCardCourse/index.vue";

//视频
import myXgplayer from "@/components/myXgplayer/index.vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";

import { reactive, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import onlineDetailsCards from "@/components/onlineDetailsCards/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";
// 引入加入收藏、取消收藏接口
import { addFavoritesList } from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";

// import { bookNew } from "@/api/addedServices/index.js";
//获取淘题搜索列表接口
// import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";
// 引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";
import { ElMessage, ElMessageBox } from "element-plus";
function handleClick(tab, event) {}
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  activeName: "first",

  // //视频尺寸
  // video: {
  //   width: "609px",
  //   height: "333px",
  // },

  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // bookNew: [], // 新书推荐
  // examSearchList: [], // 热门资源
  articleListArr: [], // 大家还看了

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId("/layout/list/onlineLearning"), // 栏目id值
    search: "", // 搜索查询
    stage: "", //学段
    theme: "", //主题
    subject: "", //学科
  },

  // classes2: JSON.parse(localStorage.getItem("classes2")) ?? [],
  // subject: JSON.parse(localStorage.getItem("subject")) ?? [],
});

// // 通过ID得到对应文字
// function byIdGetText(id, key) {
//   return mydata[key].find((item) => String(item.name) === String(id))?.label;
// }

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/onlineDetails")) {
      return;
    }
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log(res);
    mydata.articleInfo = res.data;
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.articleInfo.title;
  });
}

// init();

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.articleInfo.is_collect !== 0) {
    // 调用取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 5,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 5,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}
articleListFn();

//大家还看了内容点击
function detailsClick(id) {
  router.push({
    path: "/layout/list/onlineDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.my-rightLi {
  > p:nth-of-type(1) {
    width: calc(100% - 0px); // 减去0px而不是减去100px，是因为右侧没有时间文字
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }
  //////////第一个大模块/////////////////
  .top-detail {
    width: 100%;
    // height: 457px;
    background-color: #ffffff;
    overflow: hidden;
    // border: 1px solid rgb(68, 0, 255);

    ////////thematicCards组件
    :deep(.box-research) {
      //  border:1px solid red;
      // position: relative;
      // height: 333px !important;
    }
    .big-box {
      :deep(.el-button.el-button--primary) {
        display: none;
      }
      .box-collect {
        margin-top: 30px;
        font-size: 16px;
        font-weight: 400;
        // color: #009de0;
        display: flex;
        align-items: center;
        // position: absolute;
        padding-bottom: 20px;
        // border:1px solid blue;
        .el-icon {
          font-size: 24px;
          font-weight: 400;
          margin-right: 4px;
        }

        .collectTrue {
          color: #009de0;
        }
      }

      .box-collect:hover {
        color: #009de0;
      }
    }
  }

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    margin-top: 21px;
    // margin-bottom:16px;
    // display: flex;
    // justify-content: space-between;

    /////左边内容部分
    .box-left {
      // width: 860px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      //左边————课程简介
      .left-list {
        width: 100%;
        height: 56px;
        background-color: #ffffff;
        margin-bottom: 12px;
        border-radius: 8px;
        // height: 220px;
        // border: 1px solid red;
        :deep(.demo-tabs > .el-tabs__content) {
          padding: 32px;
          color: #6b778c;
          font-size: 32px;
          font-weight: 600;
        }
        //////每个的
        :deep(.el-tabs__item.is-top) {
          width: 100px;
          // color: red;
          // border: 1px solid rgb(255, 0, 98);
          text-align: center;
          padding: 0px;
          padding-bottom: 15px;
          // border-left:1px solid #CCCCCC;
          font-size: 16px;
          font-weight: 400px;
          // color:#333333;
        }

        ///////整体宽度
        :deep(.el-tabs__nav.is-top) {
          // border: 1px solid blue;
          margin-top: 16px;
        }
      }
      //左边————主题内容
      .left-main {
        width: 100%;
        // border: 1px solid red;
        border-radius: 8px;
        padding:16px;
        background-color: #ffffff;
      }
      //左边————大家还看了
      .left-foot {
        // width: 860px;
        // height: 277px;
        margin: 0 auto;
        margin-top: 16px;
        // padding: 30px;
        // border: 1px solid blue;
        background-color: #ffffff;
        //////适合项目部分
        .left-two-box {
          // width: 800px;
          // height: 228px;
          // border: 1px dashed yellow;
          overflow: hidden;

          ////////整体设置column组件
          :deep(.box-column) {
            // padding: 30px;
            ////
            li:hover {
              p:nth-of-type(2) {
                color: #009de0;
              }
            }

            li {
              margin-left: 20px;
              // display: flex;
              // justify-content: space-between;
              // align-items: center;
              margin-bottom: 10px;
              // border: 1px solid red;
              position: relative;
              p:first-of-type {
                font-size: 14px;
                margin-bottom: 10px;
                line-height: 24px;
                white-space: nowrap; //不折行
                text-overflow: ellipsis; //文本溢出 用省略号显示
                overflow: hidden;
              }
              p:nth-of-type(2) {
                font-size: 14px;
                font-weight: 400;
                color: #888888;
                position: absolute;
                right: 0px;
                top: 2px;
              }
            }
            li:nth-last-of-type(1) {
              margin-bottom: 0px;
            }
            .column-title {
              border-bottom: 1px solid #cccccc;
              > p {
                display: none;
              }
            }
            .column-content {
              height: 200px;

              overflow: hidden;
              overflow-y: auto;
            }
          }
        }
      }
    }
    
    .content-right{
      :deep(.box-column.column1){
        margin-top:16px;
      }
      :deep(.box-column.column2){
        margin-bottom:0px;
      }
    }
  }
}
</style>